import { module } from 'angular';

import { ColorGradeDirective, default as colorGradeDirectiveName } from './color-grade.directive';

export default module('contact.commons.toolbox.color-grad', []).directive(colorGradeDirectiveName, ColorGradeDirective).name;
